import s from './ModalFeedback.module.sass'

import React, { FC } from 'react'
import { useAppSelector } from '@app/model/store'
import { ModalFeedbackForm } from '@widgets/Common/ModalFeedback/ui/ModalFeedbackForm'
import { ModalFeedbackSelection } from '@widgets/Common/ModalFeedback/ui/ModalFeedbackSelection'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'

/**
 * @function ModalFoundMistake
 * @todo remove ts-ignore
 */
const ModalFeedback: FC = () => {
  const opened = useAppSelector((store) => store.feedback.opened)

  const category = useAppSelector((store) => store.feedback.category)

  return opened ? (
    <ErrorBoundary>
      {category ? (
        <>
          <ModalFeedbackForm category={category} />
        </>
      ) : (
        <>
          <ModalFeedbackSelection />
        </>
      )}
    </ErrorBoundary>
  ) : null
}

export default ModalFeedback
